import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["time", "date"]

  connect() {
    this.update()
    this.interval = setInterval(() => this.update(), 1000)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  update() {
    const now = new Date()

    if (this.hasTimeTarget) {
      this.timeTarget.textContent = now.toLocaleTimeString("es-ES", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
      })
    }

    if (this.hasDateTarget) {
      this.dateTarget.textContent = now.toLocaleDateString("es-ES", {
        weekday: "short",
        day: "2-digit",
        month: "short"
      }).toUpperCase()
    }
  }
}
